import { BrowseKeywordCategory } from "../../../../models/browse-keyword-category";




/** Fallback keyword browse data when API returns empty lists. */
export const BROWSE_ASSETS_KEYWORDS_DATA: BrowseKeywordCategory[] = [
    {
    name: 'Lottie Animations',
    topSearches: [
      'Loading',
      'Business',
      'User Interface',
      'Instagram Follow',
      'Message',
      'Chart',
      'Web',
      'Sports',
      'Investment',
      'Online',
      'Equipment',
      'Currency',
      'Ai',
      'Emoji',
      'Arrow',
      'Success',
      'Loader',
      'Mouse Cursor',
      'People',
      'Confetti',
      'Money',
      'Youtube Subscribe',
      'Audio Wave',
      'Charging',
      'Subscribe Button',
      'Fire',
      '5 Second Timer',
      'Finance',
      'Claude',
      'Car',
      'Instagram',
      'Gif',
      'Design Development',
      'Cat',
      'Thank You',
      'Heart',
      'Year 2026',
      'Background',
      'Svg',
      'Ai Loader',
      'Check',
      'Discord',
      'Sign Symbols',
      'Chatbot',
      'Live',
      'Signature',
      'Tiktok Follow Button',
      'Youtube',
      'Payment',
      'Star',
      '365 Days',
      'Like And Subscribe',
      'Technology',
      'Gift',
      'Email Signature',
      'Robot',
      'Tick',
      'Notification',
      'Download',
    ],
    trendingSearches: [
      'Spinner',
      'Progress Bar',
      'Skeleton Loader',
      'Pulse',
      'Bounce',
      'Fade',
      'Slide',
      'Morph',
      'Toggle',
      'Switch',
      'Checkbox',
      'Radio',
      'Button Hover',
      'Menu Open',
      'Drawer',
      'Modal',
      'Toast',
      'Alert',
      'Error',
      'Warning',
      'Info',
      'Empty State',
      'No Internet',
      '404',
      'Coming Soon',
      'Maintenance',
      'Welcome',
      'Onboarding',
      'Tutorial',
      'Swipe',
      'Drag Drop',
      'Upload File',
      'Delete',
      'Send Message',
      'Typing Indicator',
      'Voice Wave',
      'Music Equalizer',
      'Play Pause',
      'Like Heart',
      'Share',
      'Bookmark',
      'Cart Add',
      'Checkout',
      'Payment Success',
      'Order Tracking',
      'Delivery Truck',
      'Map Pin',
      'Weather Rain',
      'Sun Rise',
      'Moon Night',
      'Firework',
      'Balloon',
      'Birthday Cake',
      'Christmas',
      'Halloween',
      'New Year',
      'Rocket Launch',
      'Space Orbit',
      'Robot Walk',
    ],
  },
    {
    name: 'Illustrations',
    topSearches: [
      'Business',
      'Money',
      'Character',
      'Employee',
      'Food Delivery',
      'Credit Card',
      'Feedback',
      'Cryptocurrency',
      'Service',
      'Management',
      'Library',
      'Dollar',
      'Business Analysis',
      'Webinar',
      'People',
      'Finance',
      'Login',
      'Design Development',
      'Empty',
      'Ai',
      'School Education',
      'Car',
      'Empty State',
      'Professionals',
      'Education',
      '404',
      'Web Development',
      'No Data',
      'Technology',
      'Healthcare Medical',
      'Success',
      'Not Found',
      'Science Technology',
      'Food',
      'Error',
      'Avatar',
      'Google',
      'Arrow',
      'Man',
      'E Commerce Shopping',
      'Phone',
      'Calendar',
      'Search',
      'Woman',
      'Contact Us',
      'No Data Found',
      'User Interface',
      'Doctor',
      'Home',
      'Dashboard',
      'Social Media',
      'Location',
      'Powerpoint',
      'Security',
      'Book',
      'Isometric',
      'Team Work',
      'Startup',
      'Office',
    ],
    trendingSearches: [
      'Remote Work',
      'Online Meeting',
      'Email Marketing',
      'Data Analysis',
      'Mobile App',
      'Cloud Computing',
      'Cyber Security',
      'Digital Marketing',
      'Customer Support',
      'Product Launch',
      'Growth',
      'Investment',
      'Banking',
      'Shopping',
      'Delivery',
      'Travel',
      'Fitness',
      'Yoga',
      'Music',
      'Gaming',
      'Coding',
      'Developer',
      'Designer',
      'Creative Team',
      'Brainstorm',
      'Idea',
      'Innovation',
      'Workspace',
      'Freelance',
      'Portfolio',
      'Resume',
      'Job Search',
      'Interview',
      'Onboarding',
      'Welcome',
      'Thank You',
      'Congratulations',
      'Birthday',
      'Holiday',
      'Winter',
      'Summer',
      'Nature',
      'City',
      'Building',
      'Hospital',
      'School',
      'University',
      'Library Study',
      'Research',
      'Science Lab',
      'Robot',
      'Ai Chat',
      'Chatbot',
      'Vr',
      'Metaverse',
      'Nft',
      'Blockchain',
      'Fintech',
      'SaaS',
    ],
  },
  // stickers
  {
    name: 'Stickers',
    topSearches: [
      'Business',
      'Food',
      'Happy',
      'Thinking',
      'User Interface',
      'People',
      'Finance',
      'Money',
      'Ai',
      'Car',
      'Emoji',
      'Instagram',
      'Calendar',
      'Coin',
      'Arrow',
      'Gift',
      'Phone',
      'Star',
      'Home',
      'Abstract Shapes',
      'Design Development',
      'Book',
      'Social Media',
      'Heart',
      'User',
      'Avatar',
      'Location',
      'Youtube',
      'Check',
      'Document',
      'Shield',
      'Camera',
      'Tiktok',
      'Clock',
      'Avatars',
      'E Commerce Shopping',
      'Lock',
      'Whatsapp',
      'Robot',
      'Wallet',
      'Chatgpt Logo',
      'Sign Symbols',
      'Game',
      'Video',
      'Facebook Logo',
      'Bank',
      'Rocket',
      'Search',
      'House',
      'Crown',
      'Chat',
      'Trophy',
      'Facebook',
      'Music',
      'Stickers',
      'Education',
      'Photoshop',
      'Laptop',
      'Cloud',
    ],
    trendingSearches: [
      'Football',
      'Halloween',
      'Medal Trophy',
      'Ui Essentials',
      'Space Exploration',
      'Web3 Blockchain',
      'Digital Payment',
      'Game Asset',
      'Empty State',
      'Character',
      'Isometric',
      'Office',
      'Workspace',
      'Notification',
      'Message',
      'Like',
      'Share',
      'Download',
      'Upload',
      'Settings',
      'Profile',
      'Team',
      'Meeting',
      'Presentation',
      'Chart',
      'Analytics',
      'Growth',
      'Startup',
      'Idea',
      'Lightbulb',
      'Fire',
      'Energy',
      'Nature',
      'Plant',
      'Animal',
      'Pet',
      'Travel',
      'Plane',
      'Map',
      'Globe',
      'Weather',
      'Sun',
      'Moon',
      'Fitness',
      'Sport',
      'Health',
      'Medical',
      'Hospital',
      'School',
      'Graduation',
      'Book Stack',
      'Pencil',
      'Palette',
      'Brush',
      'Camera Lens',
      'Microphone',
      'Headphones',
      'Speaker',
      'Gaming Console',
    ],
  },
  {
    name: 'Icons',
    topSearches: [
      'Verified Badge',
      'Instagram',
      'Iconfinder',
      'Business',
      'Arrow',
      'Folder',
      'User Interface',
      'Facebook',
      'Verified Facebook',
      'Web',
      'Svg',
      'Chart',
      'Internet',
      'Safety',
      'Notion',
      'Connection',
      'Timer',
      'Stop',
      'Manager',
      'Planted',
      'Monthly',
      'Whatsapp',
      'Phone',
      'Google',
      'Youtube',
      'Home',
      'Mercedes Logo',
      'Apple',
      'Whistle',
      'Ai',
      'Location',
      'Star',
      'Verified',
      'Search',
      'Check',
      'Free',
      'Email',
      'Calendar',
      'Finance',
      'User',
      'Heart',
      'Money',
      'Avatar',
      'Car',
      'Linkedin',
      'Tiktok',
      'Telegram',
      'People',
      'Minecraft',
      'Tick',
      'Call',
      'Profile',
      'Social Media',
      'Website',
      'Spiderman',
      'Document',
      'Mail',
      'Clock',
      'Download',
    ],
    trendingSearches: [
      'Loading',
      'Design',
      'Instagram Follow',
      'Business',
      '5 Second Timer',
      'Subscribe Button',
      'Charging',
      'Confetti',
      'Emoji',
      'Animal Running',
      'Success',
      'Notification',
      'Settings',
      'Menu',
      'Close',
      'Play',
      'Pause',
      'Share',
      'Like',
      'Comment',
      'Upload',
      'Cloud',
      'Wifi',
      'Battery',
      'Camera',
      'Mic',
      'Speaker',
      'Lock',
      'Unlock',
      'Trash',
      'Edit',
      'Add',
      'Remove',
      'Filter',
      'Sort',
      'Refresh',
      'Sync',
      'Bookmark',
      'Flag',
      'Tag',
      'Gift',
      'Cart',
      'Payment',
      'Wallet',
      'Bank',
      'Crypto',
      'Chart Line',
      'Dashboard',
      'Analytics',
      'Rocket',
      'Fire',
      'Sun',
      'Moon',
      'Weather',
      'Map',
      'Pin',
      'Globe',
      'Language',
      'Translate',
    ],
  },

  {
    name: '3D Graphics',
    topSearches: [
      'Business',
      'Food',
      'Happy',
      'Thinking',
      'User Interface',
      'People',
      'Finance',
      'Money',
      'Ai',
      'Car',
      'Emoji',
      'Instagram',
      'Calendar',
      'Coin',
      'Arrow',
      'Gift',
      'Phone',
      'Star',
      'Home',
      'Abstract Shapes',
      'Design Development',
      'Book',
      'Social Media',
      'Heart',
      'User',
      'Avatar',
      'Location',
      'Youtube',
      'Check',
      'Document',
      'Shield',
      'Camera',
      'Tiktok',
      'Clock',
      'Avatars',
      'E Commerce Shopping',
      'Lock',
      'Whatsapp',
      'Robot',
      'Wallet',
      'Chatgpt Logo',
      'Sign Symbols',
      'Game',
      'Video',
      'Facebook Logo',
      'Bank',
      'Rocket',
      'Search',
      'House',
      'Crown',
      'Chat',
      'Trophy',
      'Facebook',
      'Music',
      'Stickers',
      'Education',
      'Photoshop',
      'Laptop',
      'Cloud',
    ],
    trendingSearches: [
      'Football',
      'Halloween',
      'Medal Trophy',
      'Ui Essentials',
      'Space Exploration',
      'Web3 Blockchain',
      'Digital Payment',
      'Game Asset',
      'Empty State',
      'Character',
      'Isometric',
      'Office',
      'Workspace',
      'Notification',
      'Message',
      'Like',
      'Share',
      'Download',
      'Upload',
      'Settings',
      'Profile',
      'Team',
      'Meeting',
      'Presentation',
      'Chart',
      'Analytics',
      'Growth',
      'Startup',
      'Idea',
      'Lightbulb',
      'Fire',
      'Energy',
      'Nature',
      'Plant',
      'Animal',
      'Pet',
      'Travel',
      'Plane',
      'Map',
      'Globe',
      'Weather',
      'Sun',
      'Moon',
      'Fitness',
      'Sport',
      'Health',
      'Medical',
      'Hospital',
      'School',
      'Graduation',
      'Book Stack',
      'Pencil',
      'Palette',
      'Brush',
      'Camera Lens',
      'Microphone',
      'Headphones',
      'Speaker',
      'Gaming Console',
    ],
  },
];
